// src/utils/calendarEvents.js
import supabase from '../supabase'; // Ensure the correct relative path

export async function addTestCalendarEvent() {
  const userId = 'ecd2a2fa-a084-4159-84ec-34540502d912';
  
  const newEvent = {
    user_id: userId,
    title: 'Test Event',
    description: 'This is a test event to verify calendar functionality.',
    event_date: new Date().toISOString(),
    event_type: 'test',
    // You can optionally add an end_date property if needed.
  };

  const { data, error } = await supabase
    .from('calendar_events')
    .insert([newEvent]);

  if (error) {
    console.error('Error adding calendar event:', error);
  } else {
    console.log('Event added successfully:', data);
  }
}
